export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrowBack.9139a8bd.svg","height":16,"width":9,"blurWidth":0,"blurHeight":0};